import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  touch-action: 'none';
  z-index: 100;
`;
